import React from 'react'
import { VegaHeading } from '../../vega/heading/Heading'
import { VegaIcon } from '../../vega/icon/Icon'
import { VegaTypo } from '../../vega/typography/Typography'
import style from './paymentInfo.module.scss'
import VegaColors from '../../../resources/constants/colors.module.scss'
import { useTranslation } from 'react-i18next'
import { FormatType } from '../../../utils/translation/i18n'
import { MomentOption } from '../../../utils/translation/momentUtils'

export const PaymentInfoFooter = ({
	hasBankList,
	lastDate,
	firstDate,
	isScheduled,
	isPaymentStatusFinal
}) => {
	const { i18n, t } = useTranslation()
	return (
		<>
			<div className={style.paymentSchedule}>
				<div className={style.paymentDate}>
					<VegaHeading
						tag={'h6'}
						label={t(isScheduled ? 'headerPaymentScheduled' : 'headerPaymentInit')}
						className={style.label}
					/>
					<div className={style.value}>
						<VegaIcon
							name={hasBankList && 'calendar'}
							color={VegaColors.GREEN}
							size={24}
							className={style.icon}
						/>

						<VegaTypo
							label={
								hasBankList &&
								i18n.format(firstDate, {
									type: FormatType.DATE,
									format: t('headerPaymentSentFormat')
								})
							}
							width={200}
						/>
					</div>
				</div>
				<div className={style.paymentDuration}>
					<VegaHeading
						tag={'h6'}
						label={t(
							isPaymentStatusFinal
								? 'headerPaymentFinalDuration'
								: 'headerPaymentDuration'
						)}
						className={style.label}
					/>
					<div className={style.value}>
						<VegaIcon
							name={hasBankList && 'time'}
							color={VegaColors.GREEN}
							size={24}
							className={style.icon}
						/>
						<VegaTypo
							label={
								hasBankList &&
								(isPaymentStatusFinal
									? i18n.format(lastDate, {
											momentOption: MomentOption.DURATION,
											date: firstDate,
											type: FormatType.DATE
									  })
									: i18n.format(firstDate, {
											momentOption: MomentOption.DURATION_NOW,
											type: FormatType.DATE
									  }))
							}
							width={200}
						/>
					</div>
				</div>
			</div>
		</>
	)
}
